export const supportedExtensions = ["txt", "sol", "ts", "js"];
